"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMarksheetAction = exports.EMarksheetType = exports.EStudyAction = exports.MARKSHEET_SOURCE = exports.EMarksheetState = void 0;
var EMarksheetState;
(function (EMarksheetState) {
    EMarksheetState[EMarksheetState["LOBBY"] = 0] = "LOBBY";
    EMarksheetState[EMarksheetState["PRESTART"] = 1] = "PRESTART";
    EMarksheetState[EMarksheetState["QUIZ_BUILDER"] = 2] = "QUIZ_BUILDER";
    EMarksheetState[EMarksheetState["STATION"] = 3] = "STATION";
    EMarksheetState[EMarksheetState["RESULT"] = 4] = "RESULT";
})(EMarksheetState = exports.EMarksheetState || (exports.EMarksheetState = {}));
var MARKSHEET_SOURCE;
(function (MARKSHEET_SOURCE) {
    MARKSHEET_SOURCE["QUIZ"] = "Quiz";
    MARKSHEET_SOURCE["QUICK_BUILD_QUIZ"] = "Quick build quiz";
    MARKSHEET_SOURCE["UKMLA_QUIZ"] = "UKMLA Quiz";
    MARKSHEET_SOURCE["GROUP_STUDY"] = "Qbank group study";
    MARKSHEET_SOURCE["FLAGGED_QUESTIONS_REVIEW"] = "Flagged Questions Review";
    MARKSHEET_SOURCE["FLAGGED_QUESTIONS_QUIZ"] = "Flagged Questions Quiz";
    MARKSHEET_SOURCE["SEARCH_QUESTIONS_QUIZ"] = "search Questions";
})(MARKSHEET_SOURCE = exports.MARKSHEET_SOURCE || (exports.MARKSHEET_SOURCE = {}));
var EStudyAction;
(function (EStudyAction) {
    EStudyAction[EStudyAction["START"] = 0] = "START";
    EStudyAction[EStudyAction["JOIN"] = 1] = "JOIN";
})(EStudyAction = exports.EStudyAction || (exports.EStudyAction = {}));
var EMarksheetType;
(function (EMarksheetType) {
    EMarksheetType[EMarksheetType["MOCKTEST"] = 0] = "MOCKTEST";
    EMarksheetType[EMarksheetType["SOLO_STUDY"] = 1] = "SOLO_STUDY";
    EMarksheetType[EMarksheetType["GROUP_STUDY"] = 2] = "GROUP_STUDY";
})(EMarksheetType = exports.EMarksheetType || (exports.EMarksheetType = {}));
var EMarksheetAction;
(function (EMarksheetAction) {
    EMarksheetAction[EMarksheetAction["PRESTART"] = 0] = "PRESTART";
    EMarksheetAction[EMarksheetAction["START"] = 1] = "START";
    EMarksheetAction[EMarksheetAction["END"] = 2] = "END";
    EMarksheetAction[EMarksheetAction["PAUSE"] = 3] = "PAUSE";
    EMarksheetAction[EMarksheetAction["CONTINUE"] = 4] = "CONTINUE";
    EMarksheetAction[EMarksheetAction["CONNECT"] = 5] = "CONNECT";
    EMarksheetAction[EMarksheetAction["DISCONNECT"] = 6] = "DISCONNECT";
    EMarksheetAction[EMarksheetAction["SELECT"] = 7] = "SELECT";
    EMarksheetAction[EMarksheetAction["LEFT"] = 8] = "LEFT";
    EMarksheetAction[EMarksheetAction["KICK"] = 9] = "KICK";
    EMarksheetAction[EMarksheetAction["CHOICE_SELECTED"] = 10] = "CHOICE_SELECTED";
    EMarksheetAction[EMarksheetAction["QUESTION_CHANGE"] = 11] = "QUESTION_CHANGE";
    EMarksheetAction[EMarksheetAction["TOPIC_CONCEPT_SELECTION"] = 12] = "TOPIC_CONCEPT_SELECTION";
    EMarksheetAction[EMarksheetAction["BUILDER_CONFIG_SELECTION"] = 13] = "BUILDER_CONFIG_SELECTION";
    EMarksheetAction[EMarksheetAction["STATE_CHANGE"] = 14] = "STATE_CHANGE";
    EMarksheetAction[EMarksheetAction["ANSWER_SELECTED"] = 15] = "ANSWER_SELECTED";
    EMarksheetAction[EMarksheetAction["MARK_CHECK_UNCHECK"] = 16] = "MARK_CHECK_UNCHECK";
})(EMarksheetAction = exports.EMarksheetAction || (exports.EMarksheetAction = {}));
